import * as React from 'react';

const NotFound = () => <h1>PageNotFound</h1>;

export default NotFound;
